import React from 'react';
import {ValueCell} from '../../../../../../components/initial-plan/ValueCell';
import {Data, HorizontalBar, Title, ValueContainer} from '../ProjectScopingTotals_styled';
import {Tile, TileRow} from './Tile_styled';
import {useIntl} from 'react-intl';
import {useProjectTotals} from '../ProjectScopingTotalsContext';

export const FixedPriceRightTile = (): JSX.Element => {
	const intl = useIntl();
	const {totalsData, projectData, settings} = useProjectTotals();
	return (
		<Tile>
			{settings.isBaselineProject && totalsData.baselineHours > 0 ? (
				<>
					<TileRow>
						<Title singleLine>{intl.formatMessage({id: 'baseline.hours'})}</Title>
						<Data small>
							<ValueContainer>
								<ValueCell
									noJustify
									cy={'baseline_hours'}
									type={ValueCell.VALUE_TYPE.TIME}
									value={totalsData.baselineHours}
									currencySymbol={settings.currencySymbol}
								/>
							</ValueContainer>
						</Data>
					</TileRow>
					<TileRow>
						<Title singleLine>{`${intl.formatMessage({id: 'baseline.baseline'})} - ${intl.formatMessage({
							id: 'common.projected_total_hours',
						})}`}</Title>
						<Data small>
							<ValueContainer>
								<ValueCell
									noJustify
									cy={'baseline_vs_projected_total_hours'}
									type={ValueCell.VALUE_TYPE.TIME}
									value={totalsData.baselineHours - totalsData.projectedTotalHours}
								/>
							</ValueContainer>
						</Data>
					</TileRow>
				</>
			) : (
				<>
					<TileRow>
						<Title>{intl.formatMessage({id: 'project_overview.project_dates'})}</Title>
						<Data small>{`${totalsData.startDateString} - ${totalsData.endDateString}`}</Data>
					</TileRow>
					<TileRow>
						<Title>
							{intl.formatMessage({
								id: projectData?.manualProgressOnProjectEnabled
									? 'common.progress'
									: 'project_scoping.estimated_project_progress',
							})}
						</Title>
						<Data small>
							<ValueCell
								noJustify
								cy={'progress'}
								type={ValueCell.VALUE_TYPE.PERCENTAGE}
								value={totalsData.progress}
							/>
						</Data>
					</TileRow>
				</>
			)}
			<HorizontalBar />

			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_total_billable_value_of_service'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'projected_total_value_of_service'}
							type={ValueCell.VALUE_TYPE.PRICE}
							value={totalsData.projectedBillableValueOfService}
							currencySymbol={settings.currencySymbol}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_remaining_budget'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'projected_remaining_budget'}
							type={ValueCell.VALUE_TYPE.PRICE}
							value={(projectData?.budget || 0) - totalsData.projectedBillableValueOfService}
							currencySymbol={settings.currencySymbol}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
		</Tile>
	);
};
